export const DOC_HEIGHT = '--doc-height';

export const SAFE_AREA_TOP = '--mopla-safe-area-top';
export const SAFE_AREA_BOT = '--mopla-safe-area-bottom';

export const VAR_AREA_TOP = `var(${SAFE_AREA_TOP}, 0px)`;
export const VAR_AREA_BOT = `var(${SAFE_AREA_BOT}, 0px)`;
